import { Property, Auction, Region, User } from '../types';

export const PROPERTY_IMAGES = [
  'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800',
  'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800',
  'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800',
  'https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?w=800',
  'https://images.unsplash.com/photo-1600573472550-8090b5e0745e?w=800',
  'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=800',
];

// 30 regija Srbije - kompletna lista
export const REGIONS: Region[] = [
  { id: 1, name: 'Grad Beograd', lat: 44.8176, lng: 20.4633, zoom: 11, cities: [
    { id: 1, name: 'Barajevo', lat: 44.6014, lng: 20.4683 },
    { id: 2, name: 'Voždovac', lat: 44.7755, lng: 20.4925 },
    { id: 3, name: 'Vračar', lat: 44.8028, lng: 20.4781 },
    { id: 4, name: 'Grocka', lat: 44.6722, lng: 20.7167 },
    { id: 5, name: 'Zvezdara', lat: 44.7986, lng: 20.5103 },
    { id: 6, name: 'Zemun', lat: 44.8453, lng: 20.4017 },
    { id: 7, name: 'Lazarevac', lat: 44.3831, lng: 20.2553 },
    { id: 8, name: 'Mladenovac', lat: 44.4369, lng: 20.6972 },
    { id: 9, name: 'Novi Beograd', lat: 44.8153, lng: 20.4119 },
    { id: 10, name: 'Obrenovac', lat: 44.6556, lng: 20.2000 },
    { id: 11, name: 'Palilula', lat: 44.8236, lng: 20.4694 },
    { id: 12, name: 'Rakovica', lat: 44.7550, lng: 20.4417 },
    { id: 13, name: 'Savski Venac', lat: 44.7872, lng: 20.4464 },
    { id: 14, name: 'Sopot', lat: 44.5167, lng: 20.5833 },
    { id: 15, name: 'Stari grad', lat: 44.8200, lng: 20.4600 },
    { id: 16, name: 'Surčin', lat: 44.7861, lng: 20.2756 },
    { id: 17, name: 'Čukarica', lat: 44.7833, lng: 20.4167 },
  ]},
  { id: 2, name: 'Mačvanski okrug', lat: 44.7556, lng: 19.6917, zoom: 10, cities: [
    { id: 18, name: 'Šabac', lat: 44.7556, lng: 19.6917 },
    { id: 19, name: 'Bogatić', lat: 44.8333, lng: 19.4833 },
    { id: 20, name: 'Loznica', lat: 44.5333, lng: 19.2333 },
    { id: 21, name: 'Vladimirci', lat: 44.6167, lng: 19.7833 },
    { id: 22, name: 'Koceljeva', lat: 44.4667, lng: 19.8000 },
    { id: 23, name: 'Mali Zvornik', lat: 44.3833, lng: 19.1000 },
    { id: 24, name: 'Krupanj', lat: 44.3667, lng: 19.3667 },
    { id: 25, name: 'Ljubovija', lat: 44.1833, lng: 19.3833 },
  ]},
  { id: 3, name: 'Kolubarski okrug', lat: 44.2667, lng: 20.0000, zoom: 10, cities: [
    { id: 26, name: 'Valjevo' },
    { id: 27, name: 'Osečina' },
    { id: 28, name: 'Ub' },
    { id: 29, name: 'Lajkovac' },
    { id: 30, name: 'Mionica' },
    { id: 31, name: 'Ljig' },
  ]},
  { id: 4, name: 'Podunavski okrug', cities: [
    { id: 32, name: 'Smederevo' },
    { id: 33, name: 'Smederevska Palanka' },
    { id: 34, name: 'Velika Plana' },
  ]},
  { id: 5, name: 'Braničevski okrug', cities: [
    { id: 35, name: 'Veliko Gradište', lat: 44.7667, lng: 21.5000 },
    { id: 36, name: 'Požarevac', lat: 44.6167, lng: 21.1833 },
    { id: 37, name: 'Golubac', lat: 44.6500, lng: 21.6333 },
    { id: 38, name: 'Malo Crniće', lat: 44.5667, lng: 21.2833 },
    { id: 39, name: 'Žabari', lat: 44.3667, lng: 21.2167 },
    { id: 40, name: 'Petrovac na Mlavi', lat: 44.3667, lng: 21.4167 },
    { id: 41, name: 'Kučevo', lat: 44.4833, lng: 21.6667 },
    { id: 42, name: 'Žagubica', lat: 44.1833, lng: 21.7833 },
  ]},
  { id: 6, name: 'Šumadijski okrug', lat: 44.0167, lng: 20.9167, zoom: 10, cities: [
    { id: 43, name: 'Kragujevac' },
    { id: 44, name: 'Aranđelovac' },
    { id: 45, name: 'Topola' },
    { id: 46, name: 'Rača' },
    { id: 47, name: 'Batočina' },
    { id: 48, name: 'Knić' },
    { id: 49, name: 'Lapovo' },
  ]},
  { id: 7, name: 'Pomoravski okrug', cities: [
    { id: 50, name: 'Jagodina' },
    { id: 51, name: 'Ćuprija' },
    { id: 52, name: 'Paraćin' },
    { id: 53, name: 'Svilajnac' },
    { id: 54, name: 'Despotovac' },
    { id: 55, name: 'Rekovac' },
  ]},
  { id: 8, name: 'Borski okrug', cities: [
    { id: 56, name: 'Bor' },
    { id: 57, name: 'Kladovo' },
    { id: 58, name: 'Majdanpek' },
    { id: 59, name: 'Negotin' },
  ]},
  { id: 9, name: 'Zaječarski okrug', cities: [
    { id: 60, name: 'Boljevac' },
    { id: 61, name: 'Knjaževac' },
    { id: 62, name: 'Zaječar' },
    { id: 63, name: 'Sokobanja' },
  ]},
  { id: 10, name: 'Zlatiborski okrug', cities: [
    { id: 64, name: 'Bajina Bašta' },
    { id: 65, name: 'Kosjerić' },
    { id: 66, name: 'Užice' },
    { id: 67, name: 'Požega' },
    { id: 68, name: 'Čajetina' },
    { id: 69, name: 'Arilje' },
    { id: 70, name: 'Priboj' },
    { id: 71, name: 'Nova Varoš' },
    { id: 72, name: 'Prijepolje' },
    { id: 73, name: 'Sjenica' },
  ]},
  { id: 11, name: 'Moravički okrug', cities: [
    { id: 74, name: 'Čačak' },
    { id: 75, name: 'Gornji Milanovac' },
    { id: 76, name: 'Lučani' },
    { id: 77, name: 'Ivanjica' },
  ]},
  { id: 12, name: 'Raški okrug', cities: [
    { id: 78, name: 'Kraljevo' },
    { id: 79, name: 'Vrnjačka Banja' },
    { id: 80, name: 'Raška' },
    { id: 81, name: 'Novi Pazar' },
    { id: 82, name: 'Tutin' },
  ]},
  { id: 13, name: 'Rasinski okrug', cities: [
    { id: 83, name: 'Varvarin' },
    { id: 84, name: 'Trstenik' },
    { id: 85, name: 'Ćićevac' },
    { id: 86, name: 'Kruševac' },
    { id: 87, name: 'Aleksandrovac' },
    { id: 88, name: 'Brus' },
  ]},
  { id: 14, name: 'Nišavski okrug', cities: [
    { id: 89, name: 'Niš' },
    { id: 90, name: 'Aleksinac' },
    { id: 91, name: 'Svrljig' },
    { id: 92, name: 'Merošina' },
    { id: 93, name: 'Ražanj' },
    { id: 94, name: 'Doljevac' },
    { id: 95, name: 'Gadžin Han' },
  ]},
  { id: 15, name: 'Toplički okrug', cities: [
    { id: 96, name: 'Prokuplje' },
    { id: 97, name: 'Blace' },
    { id: 98, name: 'Kuršumlija' },
    { id: 99, name: 'Žitorađa' },
  ]},
  { id: 16, name: 'Pirotski okrug', cities: [
    { id: 100, name: 'Bela Palanka' },
    { id: 101, name: 'Pirot' },
    { id: 102, name: 'Babušnica' },
    { id: 103, name: 'Dimitrovgrad' },
  ]},
  { id: 17, name: 'Jablanički okrug', cities: [
    { id: 104, name: 'Leskovac' },
    { id: 105, name: 'Bojnik' },
    { id: 106, name: 'Lebane' },
    { id: 107, name: 'Medveđa' },
    { id: 108, name: 'Vlasotince' },
    { id: 109, name: 'Crna Trava' },
  ]},
  { id: 18, name: 'Pčinjski okrug', cities: [
    { id: 110, name: 'Vladičin Han' },
    { id: 111, name: 'Surdulica' },
    { id: 112, name: 'Bosilegrad' },
    { id: 113, name: 'Trgovište' },
    { id: 114, name: 'Vranje' },
    { id: 115, name: 'Bujanovac' },
    { id: 116, name: 'Preševo' },
  ]},
  { id: 19, name: 'Kosovski okrug', cities: [
    { id: 117, name: 'Podujevo' },
    { id: 118, name: 'Obilić' },
    { id: 119, name: 'Priština' },
    { id: 120, name: 'Kosovo Polje' },
    { id: 121, name: 'Glogovac' },
    { id: 122, name: 'Štimlje' },
    { id: 123, name: 'Štrpce' },
    { id: 124, name: 'Uroševac' },
    { id: 125, name: 'Kačanik' },
    { id: 126, name: 'Lipljan' },
  ]},
  { id: 20, name: 'Pećki okrug', cities: [
    { id: 127, name: 'Istok' },
    { id: 128, name: 'Peć' },
    { id: 129, name: 'Klina' },
    { id: 130, name: 'Dečani' },
    { id: 131, name: 'Đakovica' },
  ]},
  { id: 21, name: 'Prizrenski okrug', cities: [
    { id: 132, name: 'Suva Reka' },
    { id: 133, name: 'Orahovac' },
    { id: 134, name: 'Prizren' },
    { id: 135, name: 'Gora' },
  ]},
  { id: 22, name: 'Kosovskomitrovački okrug', cities: [
    { id: 136, name: 'Zubin Potok' },
    { id: 137, name: 'Leposavić' },
    { id: 138, name: 'Zvečan' },
    { id: 139, name: 'Kosovska Mitrovica' },
    { id: 140, name: 'Srbica' },
    { id: 141, name: 'Vučitrn' },
  ]},
  { id: 23, name: 'Kosovskopomoravski okrug', cities: [
    { id: 142, name: 'Kosovska Kamenica' },
    { id: 143, name: 'Novo Brdo' },
    { id: 144, name: 'Gnjilane' },
    { id: 145, name: 'Vitina' },
  ]},
  { id: 24, name: 'Sremski okrug', cities: [
    { id: 146, name: 'Šid' },
    { id: 147, name: 'Stara Pazova' },
    { id: 148, name: 'Sremska Mitrovica' },
    { id: 149, name: 'Ruma' },
    { id: 150, name: 'Pećinci' },
    { id: 151, name: 'Irig' },
    { id: 152, name: 'Inđija' },
  ]},
  { id: 25, name: 'Severnobanatski okrug', cities: [
    { id: 153, name: 'Ada' },
    { id: 154, name: 'Kanjiža' },
    { id: 155, name: 'Kikinda' },
    { id: 156, name: 'Novi Kneževac' },
    { id: 157, name: 'Senta' },
    { id: 158, name: 'Čoka' },
  ]},
  { id: 26, name: 'Južnobanatski okrug', cities: [
    { id: 159, name: 'Alibunar' },
    { id: 160, name: 'Bela Crkva' },
    { id: 161, name: 'Vršac' },
    { id: 162, name: 'Kovačica' },
    { id: 163, name: 'Kovin' },
    { id: 164, name: 'Opovo' },
    { id: 165, name: 'Pančevo' },
    { id: 166, name: 'Plandište' },
  ]},
  { id: 27, name: 'Srednjobanatski okrug', cities: [
    { id: 167, name: 'Žitište' },
    { id: 168, name: 'Zrenjanin' },
    { id: 169, name: 'Nova Crnja' },
    { id: 170, name: 'Novi Bečej' },
    { id: 171, name: 'Sečanj' },
  ]},
  { id: 28, name: 'Severnobački okrug', cities: [
    { id: 172, name: 'Bačka Topola' },
    { id: 173, name: 'Mali Iđoš' },
    { id: 174, name: 'Subotica' },
  ]},
  { id: 29, name: 'Zapadnobački okrug', cities: [
    { id: 175, name: 'Apatin' },
    { id: 176, name: 'Kula' },
    { id: 177, name: 'Odžaci' },
    { id: 178, name: 'Sombor' },
  ]},
  { id: 30, name: 'Južnobački okrug', cities: [
    { id: 179, name: 'Bač' },
    { id: 180, name: 'Bačka Palanka' },
    { id: 181, name: 'Bački Petrovac' },
    { id: 182, name: 'Beočin' },
    { id: 183, name: 'Bečej' },
    { id: 184, name: 'Vrbas' },
    { id: 185, name: 'Žabalj' },
    { id: 186, name: 'Novi Sad' },
    { id: 187, name: 'Petrovaradin' },
    { id: 188, name: 'Srbobran' },
    { id: 189, name: 'Sremski Karlovci' },
    { id: 190, name: 'Temerin' },
    { id: 191, name: 'Titel' },
  ]},
];

export const CATEGORIES = [
  { name: 'Kuća', subcategories: ['Vikendica', 'Montažna kuća', 'Samostalna kuća', 'Kuća u nizu', 'Kuća sa imanjem'] },
  { name: 'Stan', subcategories: ['Stan u zgradi', 'Stan u kući', 'Apartman', 'Garsonjera', 'Penthouse'] },
  { name: 'Poslovni prostor', subcategories: ['Atelje', 'Lokal', 'Kancelarija', 'Magacin', 'Hala', 'Zgrada', 'Hotel', 'Restoran'] },
  { name: 'Plac', subcategories: ['Građevinsko zemljište', 'Poljoprivredno zemljište', 'Industrijsko zemljište', 'Šuma'] },
  { name: 'Garaža', subcategories: ['Parking', 'Garažno mesto', 'Podzemna garaža'] },
];

// Novi cenovnik tokena (ažurirano prema dokumentu)
export const TOKEN_PACKAGES = [
  { id: 'pkg1', tokens: 5, price: 480, currency: 'RSD', popular: false },
  { id: 'pkg2', tokens: 10, price: 900, currency: 'RSD', popular: true },
  { id: 'pkg3', tokens: 20, price: 1700, currency: 'RSD', popular: false },
  { id: 'pkg4', tokens: 30, price: 2500, currency: 'RSD', popular: false },
];

// Cenovnik oglasa
export const AD_PRICING = {
  fizickaLica: {
    prviOglas: { d7: 0, d15: 3, d30: 5 },      // Besplatno 7 dana
    ostaliOglasi: { d7: 2, d15: 3, d30: 5 },
    produzenje: { d7: 1, d15: 2, d30: 3 },
  },
  pravnaLica: {
    svakiOglas: { d7: 2, d15: 3, d30: 5 },
    produzenje: { d7: 1, d15: 2, d30: 3 },
  },
};

export const AD_DURATION_OPTIONS = [
  { days: 7, tokens: 2, label: '7 dana' },
  { days: 15, tokens: 3, label: '15 dana' },
  { days: 30, tokens: 5, label: '30 dana' },
];

export const AD_EXTENSION_OPTIONS = [
  { days: 7, tokens: 1, label: '+7 dana' },
  { days: 15, tokens: 2, label: '+15 dana' },
  { days: 30, tokens: 3, label: '+30 dana' },
];

// 20 test korisnika - 4 admina + 16 regularnih (8 fizičkih lica + 8 pravnih lica)
export const MOCK_USERS: (User & { password: string })[] = [
  // === ADMINISTRATORI (4) ===
  {
    id: 'admin1',
    email: 'kancelarija@svojnasvome.com',
    password: 'admin123',
    name: 'Glavni Administrator',
    phone: '0111234567',
    type: 'admin',
    tokens: 999,
    createdAt: '2025-01-01T00:00:00Z',
  },
  {
    id: 'admin2',
    email: 'moderator@svojnasvom.com',
    password: 'mod123',
    name: 'Moderator Milan',
    phone: '0111234568',
    type: 'admin',
    tokens: 500,
    createdAt: '2025-01-15T09:00:00Z',
  },
  {
    id: 'admin3',
    email: 'podrska@svojnasvom.com',
    password: 'podrska123',
    name: 'Podrška Korisnicima',
    phone: '0111234569',
    type: 'admin',
    tokens: 200,
    createdAt: '2025-02-01T08:00:00Z',
  },
  {
    id: 'admin4',
    email: 'tehnicka@svojnasvom.com',
    password: 'tehnicka123',
    name: 'Tehnička Podrška',
    phone: '0111234570',
    type: 'admin',
    tokens: 150,
    createdAt: '2025-02-15T10:00:00Z',
  },
  // === FIZIČKA LICA (8) ===
  {
    id: 'user1',
    email: 'marko@example.com',
    password: 'marko123',
    name: 'Marko Marković',
    phone: '0641234567',
    type: 'fizicko_lice',
    tokens: 15,
    createdAt: '2025-06-15T10:00:00Z',
  },
  {
    id: 'user2',
    email: 'ana@example.com',
    password: 'ana123',
    name: 'Ana Petrović',
    phone: '0659876543',
    type: 'fizicko_lice',
    tokens: 8,
    createdAt: '2025-08-20T14:30:00Z',
  },
  {
    id: 'user4',
    email: 'petar@example.com',
    password: 'petar123',
    name: 'Petar Nikolić',
    phone: '0612223344',
    type: 'fizicko_lice',
    tokens: 3,
    createdAt: '2025-09-05T11:00:00Z',
  },
  {
    id: 'user5',
    email: 'jovana@example.com',
    password: 'jovana123',
    name: 'Jovana Đorđević',
    phone: '0658889900',
    type: 'fizicko_lice',
    tokens: 12,
    createdAt: '2025-07-22T16:00:00Z',
  },
  {
    id: 'user6',
    email: 'stefan@example.com',
    password: 'stefan123',
    name: 'Stefan Jovanović',
    phone: '0621112233',
    type: 'fizicko_lice',
    tokens: 20,
    createdAt: '2025-05-10T12:00:00Z',
  },
  {
    id: 'user7',
    email: 'milica@example.com',
    password: 'milica123',
    name: 'Milica Stojanović',
    phone: '0634445566',
    type: 'fizicko_lice',
    tokens: 5,
    createdAt: '2025-10-01T09:30:00Z',
  },
  {
    id: 'user8',
    email: 'nikola@example.com',
    password: 'nikola123',
    name: 'Nikola Todorović',
    phone: '0647778899',
    type: 'fizicko_lice',
    tokens: 0,
    createdAt: '2025-11-15T15:00:00Z',
  },
  {
    id: 'user9',
    email: 'jelena@example.com',
    password: 'jelena123',
    name: 'Jelena Ilić',
    phone: '0659991122',
    type: 'fizicko_lice',
    tokens: 25,
    createdAt: '2025-04-20T11:00:00Z',
  },
  // === PRAVNA LICA - AGENCIJE (8) ===
  {
    id: 'user3',
    email: 'agencija@nekretnine.rs',
    password: 'agencija123',
    name: 'Nekretnine Plus d.o.o.',
    phone: '0214445566',
    type: 'pravno_lice',
    companyName: 'Nekretnine Plus d.o.o.',
    tokens: 50,
    createdAt: '2025-03-10T09:00:00Z',
  },
  {
    id: 'user10',
    email: 'info@belgrade-estate.rs',
    password: 'belgrade123',
    name: 'Belgrade Estate',
    phone: '0112334455',
    type: 'pravno_lice',
    companyName: 'Belgrade Estate d.o.o.',
    tokens: 100,
    createdAt: '2025-02-01T08:00:00Z',
  },
  {
    id: 'user11',
    email: 'office@novisad-nekretnine.rs',
    password: 'novisad123',
    name: 'NS Nekretnine',
    phone: '0215556677',
    type: 'pravno_lice',
    companyName: 'NS Nekretnine d.o.o.',
    tokens: 75,
    createdAt: '2025-03-20T10:00:00Z',
  },
  {
    id: 'user12',
    email: 'prodaja@vrh-nekretnine.rs',
    password: 'vrh123',
    name: 'Vrh Nekretnine',
    phone: '0117889900',
    type: 'pravno_lice',
    companyName: 'Vrh Nekretnine d.o.o.',
    tokens: 30,
    createdAt: '2025-06-01T14:00:00Z',
  },
  {
    id: 'user13',
    email: 'kontakt@zlatna-kuca.rs',
    password: 'zlatna123',
    name: 'Zlatna Kuća',
    phone: '0112223344',
    type: 'pravno_lice',
    companyName: 'Zlatna Kuća d.o.o.',
    tokens: 60,
    createdAt: '2025-04-15T09:00:00Z',
  },
  {
    id: 'user14',
    email: 'info@nis-nekretnine.rs',
    password: 'nis123',
    name: 'Niš Nekretnine',
    phone: '0185556677',
    type: 'pravno_lice',
    companyName: 'Niš Nekretnine d.o.o.',
    tokens: 40,
    createdAt: '2025-05-20T11:30:00Z',
  },
  {
    id: 'user15',
    email: 'office@kragujevac-home.rs',
    password: 'kg123',
    name: 'KG Home',
    phone: '0347778899',
    type: 'pravno_lice',
    companyName: 'KG Home d.o.o.',
    tokens: 35,
    createdAt: '2025-07-10T10:00:00Z',
  },
  {
    id: 'user16',
    email: 'prodaja@subotica-stan.rs',
    password: 'subotica123',
    name: 'Subotica Stan',
    phone: '0249991122',
    type: 'pravno_lice',
    companyName: 'Subotica Stan d.o.o.',
    tokens: 45,
    createdAt: '2025-08-05T13:00:00Z',
  },
];

// Mock properties data
export const MOCK_PROPERTIES: Property[] = [
  {
    id: 'p1',
    adKind: 'Ponuda',
    adType: 'Prodaja',
    category: 'Stan',
    subcategory: 'Stan u zgradi',
    title: 'Luksuzan trosoban stan na Vračaru',
    description: 'Predivan stan u mirnoj ulici na Vračaru. Renoviran 2024. godine sa vrhunskim materijalima. Idealna lokacija blizu svih sadržaja - škole, vrtići, prodavnice, parkovi.',
    price: 185000,
    currency: 'EUR',
    squareMeters: 85,
    rooms: 3,
    floor: 4,
    totalFloors: 6,
    heating: 'CG',
    location: { region: 'Grad Beograd', city: 'Vračar', address: 'Njegoševa 45', lat: 44.7983, lng: 20.4756 },
    features: { lift: true, terasa: true, klima: true, uknjizen: true, odmahUseljiv: true },
    images: [PROPERTY_IMAGES[0], PROPERTY_IMAGES[1], PROPERTY_IMAGES[2]],
    contactPhone: '0641234567',
    contactEmail: 'marko@example.com',
    userId: 'user1',
    views: 245,
    approved: true,
    featured: true,
    createdAt: '2025-12-15T10:00:00Z',
    expiresAt: '2026-01-15T10:00:00Z',
    status: 'active',
  },
  {
    id: 'p2',
    adKind: 'Ponuda',
    adType: 'Izdavanje',
    category: 'Stan',
    subcategory: 'Garsonjera',
    title: 'Garsonjera u centru Novog Sada',
    description: 'Kompletno opremljena garsonjera u strogom centru. Pogodna za studente ili mlade profesionalce.',
    price: 250,
    currency: 'EUR',
    squareMeters: 28,
    rooms: 1,
    floor: 2,
    totalFloors: 4,
    heating: 'EG',
    utilities: 50,
    location: { region: 'Južnobački okrug', city: 'Novi Sad', address: 'Zmaj Jovina 15', lat: 45.2551, lng: 19.8450 },
    features: { klima: true, internet: true, odmahUseljiv: true },
    images: [PROPERTY_IMAGES[1], PROPERTY_IMAGES[3]],
    contactPhone: '0659876543',
    contactEmail: 'ana@example.com',
    userId: 'user2',
    views: 178,
    approved: true,
    featured: false,
    createdAt: '2025-12-20T14:30:00Z',
    expiresAt: '2026-01-20T14:30:00Z',
    status: 'active',
  },
  {
    id: 'p3',
    adKind: 'Ponuda',
    adType: 'Prodaja',
    category: 'Kuća',
    subcategory: 'Samostalna kuća',
    title: 'Porodična kuća sa dvorištem na Senjaku',
    description: 'Prostrana porodična kuća sa velikim dvorištem. Tri sprata, garaža za dva automobila, bazen. Idealna za veliku porodicu.',
    price: 650000,
    currency: 'EUR',
    squareMeters: 320,
    rooms: 6,
    totalFloors: 3,
    heating: 'CG',
    plotArea: 800,
    location: { region: 'Grad Beograd', city: 'Savski Venac', address: 'Senjak', lat: 44.7856, lng: 20.4345 },
    features: { garaza: true, terasa: true, uknjizen: true, videoNadzor: true, parkingMesto: true },
    images: [PROPERTY_IMAGES[2], PROPERTY_IMAGES[4], PROPERTY_IMAGES[5]],
    contactPhone: '0214445566',
    contactEmail: 'agencija@nekretnine.rs',
    userId: 'user3',
    views: 512,
    approved: true,
    featured: true,
    createdAt: '2025-11-10T09:00:00Z',
    expiresAt: '2026-02-10T09:00:00Z',
    status: 'active',
  },
  {
    id: 'p4',
    adKind: 'Ponuda',
    adType: 'Prodaja',
    category: 'Plac',
    subcategory: 'Građevinsko zemljište',
    title: 'Građevinsko zemljište na Zlatiboru',
    description: 'Atraktivna lokacija za izgradnju vikendice ili apartmana. Struja i voda na parceli. Pogled na planinu.',
    price: 45000,
    currency: 'EUR',
    squareMeters: 1200,
    plotArea: 1200,
    location: { region: 'Zlatiborski okrug', city: 'Čajetina', address: 'Zlatibor', lat: 43.7306, lng: 19.7003 },
    features: { struja: true, voda: true, putDoObjekta: true, dozvoljenaGradnja: true },
    images: [PROPERTY_IMAGES[4], PROPERTY_IMAGES[5]],
    contactPhone: '0612223344',
    userId: 'user4',
    views: 89,
    approved: true,
    featured: false,
    createdAt: '2025-12-01T11:00:00Z',
    expiresAt: '2026-01-01T11:00:00Z',
    status: 'active',
  },
  {
    id: 'p5',
    adKind: 'Ponuda',
    adType: 'Izdavanje',
    category: 'Poslovni prostor',
    subcategory: 'Kancelarija',
    title: 'Kancelarijski prostor u poslovnom centru',
    description: 'Moderno opremljen kancelarijski prostor u novom poslovnom centru. Parking obezbeđen. Recepcija i čistoća u ceni.',
    price: 800,
    currency: 'EUR',
    squareMeters: 120,
    floor: 5,
    totalFloors: 12,
    heating: 'CG',
    location: { region: 'Grad Beograd', city: 'Novi Beograd', address: 'Bulevar Mihajla Pupina 10', lat: 44.8184, lng: 20.4091 },
    features: { lift: true, klima: true, internet: true, videoNadzor: true, parkingMesto: true },
    images: [PROPERTY_IMAGES[3], PROPERTY_IMAGES[0]],
    contactPhone: '0214445566',
    userId: 'user3',
    views: 156,
    approved: true,
    featured: false,
    createdAt: '2025-12-18T08:00:00Z',
    expiresAt: '2026-01-18T08:00:00Z',
    status: 'active',
  },
  {
    id: 'p6',
    adKind: 'Ponuda',
    adType: 'Prodaja',
    category: 'Stan',
    subcategory: 'Penthouse',
    title: 'Penthouse sa terasom na Dorćolu',
    description: 'Ekskluzivni penthouse na poslednjem spratu sa panoramskim pogledom na Dunav. Velika terasa od 50m². Dva parking mesta u garaži.',
    price: 380000,
    currency: 'EUR',
    squareMeters: 150,
    rooms: 4,
    floor: 8,
    totalFloors: 8,
    heating: 'CG',
    location: { region: 'Grad Beograd', city: 'Stari grad', address: 'Dorćol', lat: 44.8250, lng: 20.4650 },
    features: { lift: true, terasa: true, garaza: true, klima: true, uknjizen: true, videoNadzor: true },
    images: [PROPERTY_IMAGES[0], PROPERTY_IMAGES[2], PROPERTY_IMAGES[5]],
    contactPhone: '0658889900',
    userId: 'user5',
    views: 423,
    approved: true,
    featured: true,
    createdAt: '2025-12-10T16:00:00Z',
    expiresAt: '2026-02-10T16:00:00Z',
    status: 'active',
  },
];

// Mock demands (Potražnja)
export const MOCK_DEMANDS: Property[] = [
  {
    id: 'd1',
    adKind: 'Potražnja',
    adType: 'Prodaja',
    category: 'Stan',
    title: 'Tražim dvosoban stan u Beogradu',
    description: 'Tražim dvosoban stan za kupovinu u Beogradu, poželjno na Vračaru ili Zvezdari. Budžet do 120.000 EUR.',
    price: 120000,
    currency: 'EUR',
    squareMeters: 60,
    rooms: 2,
    location: { region: 'Grad Beograd', city: 'Vračar', lat: 44.7983, lng: 20.4756 },
    features: { lift: true, uknjizen: true },
    images: [],
    contactPhone: '0641234567',
    userId: 'user1',
    views: 45,
    approved: true,
    featured: false,
    createdAt: '2025-12-28T10:00:00Z',
    status: 'active',
  },
  {
    id: 'd2',
    adKind: 'Potražnja',
    adType: 'Izdavanje',
    category: 'Stan',
    title: 'Tražim stan za izdavanje u Novom Sadu',
    description: 'Student sam i tražim stan ili sobu za izdavanje u blizini Filozofskog fakulteta. Budžet do 200 EUR mesečno.',
    price: 200,
    currency: 'EUR',
    squareMeters: 30,
    location: { region: 'Južnobački okrug', city: 'Novi Sad', lat: 45.2551, lng: 19.8450 },
    features: { internet: true },
    images: [],
    contactPhone: '0659876543',
    userId: 'user2',
    views: 32,
    approved: true,
    featured: false,
    createdAt: '2025-12-25T14:00:00Z',
    status: 'active',
  },
  {
    id: 'd3',
    adKind: 'Potražnja',
    adType: 'Prodaja',
    category: 'Plac',
    title: 'Tražim plac za vikendicu na Fruškoj Gori',
    description: 'Tražim plac za izgradnju vikendice na Fruškoj Gori, 500-1000 m². Sa strujom i vodom ako je moguće.',
    price: 30000,
    currency: 'EUR',
    squareMeters: 800,
    plotArea: 800,
    location: { region: 'Sremski okrug', city: 'Irig', lat: 45.0933, lng: 19.8633 },
    features: { struja: true, voda: true },
    images: [],
    contactPhone: '0612223344',
    userId: 'user4',
    views: 18,
    approved: true,
    featured: false,
    createdAt: '2025-12-20T11:00:00Z',
    status: 'active',
  },
];

// Mock auctions
export const MOCK_AUCTIONS: Auction[] = [
  {
    id: 'a1',
    adKind: 'Aukcija',
    adType: 'Prodaja',
    category: 'Stan',
    subcategory: 'Stan u zgradi',
    title: 'Aukcija - Dvosoban stan na Novom Beogradu',
    description: 'Prodaje se dvosoban stan na aukciji. Početna cena ispod tržišne vrednosti. Stan je u dobrom stanju, potrebno minimalno ulaganje.',
    price: 85000,
    currency: 'EUR',
    squareMeters: 58,
    rooms: 2,
    floor: 3,
    totalFloors: 10,
    heating: 'CG',
    location: { region: 'Grad Beograd', city: 'Novi Beograd', address: 'Blok 45', lat: 44.8050, lng: 20.3890 },
    features: { lift: true, terasa: true, uknjizen: true },
    images: [PROPERTY_IMAGES[1], PROPERTY_IMAGES[3]],
    contactPhone: '0214445566',
    userId: 'user3',
    views: 289,
    approved: true,
    featured: true,
    createdAt: '2025-12-15T09:00:00Z',
    status: 'active',
    startingPrice: 85000,
    currentPrice: 92000,
    auctionEndsAt: '2026-01-20T18:00:00Z',
    bids: [
      { id: 'b1', auctionId: 'a1', userId: 'user1', userName: 'Marko M.', amount: 87000, status: 'approved', createdAt: '2025-12-20T10:00:00Z' },
      { id: 'b2', auctionId: 'a1', userId: 'user2', userName: 'Ana P.', amount: 89000, comment: 'Zainteresovan sam, spreman za brzu transakciju', status: 'approved', createdAt: '2025-12-22T14:00:00Z' },
      { id: 'b3', auctionId: 'a1', userId: 'user4', userName: 'Petar N.', amount: 92000, status: 'approved', createdAt: '2025-12-28T16:00:00Z' },
    ],
  },
  {
    id: 'a2',
    adKind: 'Aukcija',
    adType: 'Prodaja',
    category: 'Kuća',
    subcategory: 'Vikendica',
    title: 'Aukcija - Vikendica na Kopaoniku',
    description: 'Prodaje se vikendica na Kopaoniku putem aukcije. Idealna lokacija, 500m od ski staze. Kompletno nameštena.',
    price: 120000,
    currency: 'EUR',
    squareMeters: 95,
    rooms: 3,
    totalFloors: 2,
    heating: 'EG',
    plotArea: 300,
    location: { region: 'Raški okrug', city: 'Raška', address: 'Kopaonik', lat: 43.2861, lng: 20.8158 },
    features: { garaza: true, terasa: true, klima: true },
    images: [PROPERTY_IMAGES[2], PROPERTY_IMAGES[4]],
    contactPhone: '0658889900',
    userId: 'user5',
    views: 445,
    approved: true,
    featured: true,
    createdAt: '2025-12-10T12:00:00Z',
    status: 'active',
    startingPrice: 120000,
    currentPrice: 135000,
    auctionEndsAt: '2026-01-25T20:00:00Z',
    bids: [
      { id: 'b4', auctionId: 'a2', userId: 'user1', userName: 'Marko M.', amount: 125000, status: 'approved', createdAt: '2025-12-18T11:00:00Z' },
      { id: 'b5', auctionId: 'a2', userId: 'user3', userName: 'Nekretnine Plus', amount: 130000, comment: 'Kupujem u ime klijenta', status: 'approved', createdAt: '2025-12-20T09:00:00Z' },
      { id: 'b6', auctionId: 'a2', userId: 'user4', userName: 'Petar N.', amount: 135000, status: 'approved', createdAt: '2025-12-25T15:00:00Z' },
    ],
  },
];
